import MABrokerDealerPage from './MABrokerDealerPage'
// Uncomment the below to migrate to stateful component
// import MABrokerDealerPageContainer from './MABrokerDealerPageContainer'

export { MABrokerDealerPage }
export default MABrokerDealerPage
// Uncomment the below to migrate to stateful component
// export { MABrokerDealerPageContainer }
// export default { MABrokerDealerPageContainer }
